import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { formatMoney, getWeeklyPrice } from '@spa/shared/utils/money';

const PropertyPrice = ({ price, isUniresidences }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation('translations');
  const { currencyCode, amount } = price;
  const recurrence = currencyCode === 'GBP' && isUniresidences ? t('week') : t('month');

  if (isUniresidences && currencyCode === 'GBP') {
    const weeklyPrice = getWeeklyPrice(amount);

    return (
      <React.Fragment>
        <span>{formatMoney(weeklyPrice, currencyCode, language)}</span> /{recurrence}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <span>{formatMoney(amount, currencyCode, language)}</span> /{recurrence}
    </React.Fragment>
  );
};

PropertyPrice.propTypes = {
  price: PropTypes.object.isRequired,
  isUniresidences: PropTypes.bool
};

export default PropertyPrice;
